import { Page, SelectFilter } from '@/components';
import { SBE_SWAPS } from '@/constants';
import { Flex, Heading, useTableProps } from '@blockanalitica/ui';
import { useMemo } from 'react';
import EventsTable from './EventsTable';
import HistoricTabs from './HistoricTabs';

export default function SBEActivityPage() {
  const { pagination, sorting, filters } = useTableProps({
    pageSize: 10,
    initialSorting: '-order_index',
    filtersDebounceTime: 50
  });

  const selectFilterOptions = useMemo(() => {
    const options = [{ label: 'All events', value: '' }];
    options.push(
      ...Object.entries(SBE_SWAPS).map(([key, value]) => ({
        label: value,
        value: key,
        selected: key === filters.filtersApplied.operation
      }))
    );
    return options;
  }, [filters]);
  return (
    <Page title="Activity">
      <HistoricTabs />
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        alignContent="center"
        alignItems="center">
        <Heading size="3">Events</Heading>
        <SelectFilter
          key="operation-filter"
          filterField="operation"
          options={selectFilterOptions}
          {...filters}
        />
      </Flex>
      <EventsTable
        pagination={pagination}
        sorting={sorting}
        filters={filters}
      />
    </Page>
  );
}
